import api, { ApiResponse, QueryResponse } from './api';

export interface AuditRow {
  id: string;
  action: string;
  entity_type: string;
  entity_id: string;
  old_values: Record<string, any> | null;
  new_values: Record<string, any> | null;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
  user_id: string | null;
  user_email: string | null;
  user_first_name: string | null;
  user_last_name: string | null;
  api_key_id: string | null;
  api_key_name: string | null;
  source: 'ui' | 'mcp' | 'api' | 'system' | null;
  mcp_client_name: string | null;
}

export interface AuditQueryFilters {
  entity_type?: string;
  entity_id?: string;
  action?: string;
  user_id?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export const auditService = {
  query: async (filters: AuditQueryFilters = {}): Promise<{ data: AuditRow[]; total: number }> => {
    const response = await api.post<QueryResponse<AuditRow>>('/audit/query', filters);
    return { data: response.data.data, total: response.data._meta?.total ?? 0 };
  },

  entityTypes: async (): Promise<string[]> => {
    const response = await api.get<ApiResponse<string[]>>('/audit/entity-types');
    return response.data.data ?? [];
  },
};
